<button class="w-full rounded-lg hover:bg-drawer-hover" (click)="popover.toggle($event)">
  <ng-container *ngTemplateOutlet="userInfo; context: { isBtn: true }" ></ng-container>
</button>

<p-popover #popover>
  <div class="w-[238px] p-1 flex flex-col gap-1 items-start text-sm">
    <ng-container *ngTemplateOutlet="userInfo"></ng-container>
    <ng-container *ngTemplateOutlet="separator"></ng-container>
    <a [routerLink]="profileUrl" (click)="closeMenu()" class="w-full text-left py-1 px-2 rounded-md hover:bg-border">
      <span class="fas fa-fw fa-gear text-muted-foreground mr-1"></span>
      {{ 'drawer.profile.myProfile' | translate }}
    </a>
    <button data-testid="help-btn" (click)="displayHelp = true; closeMenu()" class="w-full text-left py-1 px-2 rounded-md hover:bg-border">
      <span class="fas fa-fw fa-keyboard text-muted-foreground mr-1"></span>
      {{ 'drawer.profile.shortcutsHelp' | translate }}
    </button>
    <ng-container *ngTemplateOutlet="separator"></ng-container>
    <button (click)="logout()" class="w-full text-left py-1 px-2 rounded-md hover:bg-border">
      <span class="fas fa-fw fa-arrow-right-from-bracket text-muted-foreground mr-1"></span>
      {{ 'drawer.profile.logout' | translate }}
    </button>
  </div>
</p-popover>

<p-dialog
  [header]="'drawer.profile.shortcutsHelp' | translate"
  [(visible)]="displayHelp"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '25vw' }"
>
  @if (hotkeysService.getShortcuts().length === 0) {
    <h3 class="font-bold mb-2">{{ 'drawer.bookmarks' | translate}}</h3>
    <div [innerHTML]="'drawer.noBookmarks' | translate"></div>
  } @else {
    @for (group of hotkeysService.getShortcuts(); track group.group) {
      <h3 class="font-bold mb-2">{{ group.group }}</h3>
      <ul class="mb-4">
        @for (hotkey of group.hotkeys; track $index) {
          <li class="flex gap-4 justify-between py-1">
            <span>{{ hotkey.description }}</span>
            <app-shortcut [hotkey]="hotkey.keys"></app-shortcut>
          </li>
        }
      </ul>
    }
  }
</p-dialog>

<ng-template #userInfo let-isBtn="isBtn">
  <div class="w-full text-sm p-2 flex gap-2 items-center">
    <div class="size-8 border rounded-lg p-1 flex items-center justify-center">
      <span class="fas fa-user"></span>
    </div>
    <div class="text-left flex-1 flex flex-col">
      <div class="font-medium">{{ userName }}</div>
      <div class="text-xs font-extralight">{{ userMail }}</div>
    </div>
    @if (isBtn) {
      <div class="p-1">
        <span class="fas fa-chevron-right"></span>
      </div>
    }
  </div>
</ng-template>

<ng-template #separator>
  <hr class="border-border w-[calc(100%+8px)] -ml-1" />
</ng-template>